import React from 'react'
import Avatar from 'components/Avatar'
import Control from 'components/Control/Control'
import ApartmentIcon from 'components/icons/ApartmentIcon'
import CustomTag from 'components/CustomTag'
import { COLORS } from 'theme'
import {
  SubFLex,
  SecondaryHeading,
  GreyText,
  StyledP,
  EditorContent,
  VerticalDivider,
  NameAdd1,
  TextLight1,
  BoldTextDate,
  RewardTite,
} from './style'
import Flex from 'components/Flex'
import moment from 'moment'
import FileReaderVisibleOnly from 'components/Uploader/FileReaderVisibleOnly'
import AwardsIconWork from 'components/icons/AwardsIconWork'
import { ExclamationCircleFilled } from '@ant-design/icons'
import styled from 'styled-components'

const PendingIcon = styled(ExclamationCircleFilled)`
  color: #eb5d60;
  font-size: 16px;
  margin-left: 8px;
`

const ProjectSection = ({
  studentDetails,
  pendingData
}) => {

  const approvedProjects = studentDetails?.resume?.projects || []
  const pendingProjects = pendingData?.resume?.projects || []
  
  const mergedProjects = approvedProjects.map(approved => {
    const pendingChange = pendingProjects.find(
      pending => pending.id === approved.id || pending._tempId === approved.id || pending._itemId === approved.id
    )
    
    if (pendingChange && pendingChange._pendingFields) {
      return {
        ...approved,
        ...pendingChange,
        _requestId: Object.values(pendingChange._pendingFields)[0]?._requestId,
        _status: Object.values(pendingChange._pendingFields)[0]?._status,
        _hasPendingChanges: true
      }
    }
    
    return approved
  })
  
  const newPendingProjects = pendingProjects.filter(
    pending => pending._isNew || !approvedProjects.find(approved => approved.id === pending.id || approved.id === pending._itemId || approved.id === pending._tempId)
  )
  
  mergedProjects.push(...newPendingProjects)
  
  const allProjects = mergedProjects

  const hasFieldPending = (project, fieldName) => {
    return project?._pendingFields && project._pendingFields[fieldName] !== undefined
  }

  const DateDiff = (start, end) => {
    if (!start) {
      return '';
    }
    
    const StartSplit = start.split('/')
    if (!StartSplit || StartSplit.length < 2) {
      return '';
    }
    
    const EndSplit = end ? end.split('/') : null
    if (end && (!EndSplit || EndSplit.length < 2)) {
      return '';
    }
    
    try {
      const startDate = new Date(StartSplit[1], StartSplit[0], 1)
      const endDate = end ? new Date(EndSplit[1], EndSplit[0], 1) : new Date()
      
      const diffInMonths =
        (endDate.getFullYear() - startDate.getFullYear()) * 12 +
        (endDate.getMonth() - startDate.getMonth()) + 1

      if (diffInMonths >= 12) {
        const years = Math.floor(diffInMonths / 12) 
        const months = diffInMonths % 12 
        return `(${years === 1 ?   years + ' year' : years > 1 ? years + ' years' : '' } ${months === 1 ?   months + ' month' : months > 1 ? months + ' months' : '' })`;
    } else {
        return `(${diffInMonths === 1 ?   diffInMonths + ' month' : diffInMonths > 1 ? diffInMonths + ' months' : '' })`;
      }

    } catch (error) {
      return '';
    }
  }

  return (
    
      <SubFLex column gap="25px">
      {allProjects.map((item, index) => {
        return (
        <SubFLex gap="12px" key={index+"project"}>
          <div>
            <Avatar
              background="none"
              src={''}
              size={48}
              icon={<ApartmentIcon />}
              boxShadow={true}
              padding="5px"
            />
          </div>
          <SubFLex column style={{width:'90%'}}>
            <Flex centerVertically gap="10px">
              <div style={{ flex: 1 }}>
                <SecondaryHeading style={{ wordBreak: 'break-word', overflowWrap: 'anywhere', margin: '1% 1% 1% 0' }}>
                  {item?.title}
                  {/* {hasFieldPending(item, 'title') && <PendingIcon />} */}
                  {item?.title && item?.organization && ' - '}
                  {item?.organization}
                  {/* {hasFieldPending(item, 'organization') && <PendingIcon />} */}
                </SecondaryHeading>
              </div>
              {item?._pendingFields && (
                <CustomTag
                  message={item?.id ? "Need Approval" : "Need Approval"}
                  bordered={true}
                  background={'#eb5d60'}
                  border={'#eb5d60'}
                  color={'#fff'}
                />
              )}
            </Flex>
            {(item?.started_in || item?.ended_in) && (
              <GreyText color={COLORS.GREY_T_60} style={{ display: 'flex', alignItems: 'center' }}>
                <span>
                  {moment(item?.started_in,'MM/YYYY')?.format('MMM YYYY')} - {moment(item?.ended_in,'MM/YYYY')?.format('MMM YYYY')} {DateDiff(item?.started_in, item?.ended_in)}
                </span>
                {/* {(hasFieldPending(item, 'started_in') || hasFieldPending(item, 'ended_in')) && <PendingIcon />} */}
              </GreyText>
            )}
            {item?.skill_set?.length > 0 &&
            <SecondaryHeading fontWeight="600" style={{ display: 'flex', alignItems: 'center' }}>
              Skills
              {/* {hasFieldPending(item, 'skill_set') && <PendingIcon />} */}
            </SecondaryHeading>
            }
            <SubFLex centerVertically gap="5px" marginBottom="15px" wrap>
            {item?.skill_set?.map((value,key) => (
              <CustomTag
                message={value?.name}
                key={key+"skill"}
                bordered={true}
                background={'#F2F3F5'}
                border={'#F2F3F5'}
              />
              ))}
          
          </SubFLex>
          <Flex centerVertically>
  {item.function &&
    <>
      <NameAdd1 column flexStart>
        <TextLight1 color={COLORS.GREY_T_20}>Function</TextLight1>
        <BoldTextDate color={COLORS.GREY_T_20} style={{ display: 'flex', alignItems: 'center' }}>
          {item.function}
          {/* {hasFieldPending(item, 'function') && <PendingIcon />} */}
        </BoldTextDate>
      </NameAdd1>
      {item.role && <VerticalDivider type="vertical" />}
    </>
  }
  {item.role &&
    <>
      <NameAdd1 column flexStart>
        <TextLight1 color={COLORS.GREY_T_20}>Role</TextLight1>
        <BoldTextDate color={COLORS.GREY_T_20} style={{ display: 'flex', alignItems: 'center' }}>
          {item.role}
          {/* {hasFieldPending(item, 'role') && <PendingIcon />} */}
        </BoldTextDate>
      </NameAdd1>
      {item.industry && <VerticalDivider type="vertical" />}
    </>
  }
  {item.industry &&

      <NameAdd1 column flexStart>
        <TextLight1 color={COLORS.GREY_T_20}>Industry</TextLight1>
        <BoldTextDate color={COLORS.GREY_T_20} style={{ display: 'flex', alignItems: 'center' }}>
          {item.industry}
          {/* {hasFieldPending(item, 'industry') && <PendingIcon />} */}
        </BoldTextDate>
      </NameAdd1>
  
  }
</Flex>
            
            {item?.description && (
            <StyledP style={{ display: 'flex', alignItems: 'flex-start' }}>
            <EditorContent
              dangerouslySetInnerHTML={{
                __html: item?.description || '',
              }}
             />
             {/* {hasFieldPending(item, 'description') && <PendingIcon />} */}
             </StyledP>
             )}
             {item?.certificate &&
            <Control top="10px">
              <FileReaderVisibleOnly file={item?.certificate} />
            </Control>
             }
             {item?.awards?.length > 0 &&  studentDetails?.student?.isExpCandidate &&(
                  <RewardTite>Rewards and Recognition </RewardTite>
                )}
                {item?.awards?.map((value, key) => (
                  
                    <SubFLex column gap="25px" marginBottom="10px" key={key+"awards"}>
                      <SubFLex gap="12px">
                        <div>
                          <Avatar
                            background="none"
                            src={''}
                            size={48}
                            icon={<AwardsIconWork />}
                            boxShadow={true}
                            padding="5px"
                          />
                        </div>
                        <SubFLex column style={{width:'90%'}}>
                          <SecondaryHeading>{value?.title}</SecondaryHeading>

                          <GreyText color={COLORS.GREY_T_60}>
                            {moment(value?.awarded_on).format('DD MMM YYYY')}
                          </GreyText>

                          <StyledP>
                            {' '}
                            <EditorContent
                              dangerouslySetInnerHTML={{
                                __html: value?.description || '',
                              }}
                            />{' '}
                          </StyledP>
                          {value?.certificate && (
                            <FileReaderVisibleOnly file={value?.certificate} />
                          )}
                        </SubFLex>
                      </SubFLex>
                    </SubFLex>
                  
                ))}
          </SubFLex>
        </SubFLex>
        )
      })}
      </SubFLex>
    
  )
}

export default ProjectSection